/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Title_AccentInputs */

const tr_landing_telegram_title_accent = /** @type {(inputs: Landing_Telegram_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hepsi telefonunuzdan.`)
};

const en_landing_telegram_title_accent = /** @type {(inputs: Landing_Telegram_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All from your phone.`)
};

const de_landing_telegram_title_accent = /** @type {(inputs: Landing_Telegram_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles von Ihrem Smartphone aus.`)
};

const ru_landing_telegram_title_accent = /** @type {(inputs: Landing_Telegram_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всё с вашего телефона.`)
};

/**
* | output |
* | --- |
* | "All from your phone." |
*
* @param {Landing_Telegram_Title_AccentInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_title_accent = /** @type {((inputs?: Landing_Telegram_Title_AccentInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Title_AccentInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_title_accent(inputs)
	if (locale === "de") return de_landing_telegram_title_accent(inputs)
	if (locale === "ru") return ru_landing_telegram_title_accent(inputs)
	return tr_landing_telegram_title_accent(inputs)
});